import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import { Bar } from "@ant-design/plots";
import * as Global from "../../styles/Global";

export const BarPlot = ({
  data,
  customConfig,
  style,
  x,
  y,
  seriesField,
  darkMode,
  type,
}) => {
  //   console.log("BarPlot");
  //   console.log("BarPlot data: ", data);
  console.log("BarPlot x: ", x);
  console.log("BarPlot y: ", y);
  const config = customConfig
    ? customConfig
    : {
        data,
        xField: x ? x : "key_as_string",
        yField: y ? y : "doc_count",
        seriesField: seriesField ? seriesField : "category",
        isStacked: true,
        padding: type === "tournamentPlacement" && [0, 42, 20, 25],
        barStyle: {
          fill: type === "tournamentPlacement" && "#578AF1",
        },
        label: {
          style: {
            fill: darkMode ? "#fff" : "#333",
            fontSize: type === "tournamentPlacement" ? ".6em" : 13,
          },
          position: "overlap",
          content: (item) => {
            if (type === "tournamentPlacement") {
              return `${item.percent}`;
            }
          },
        },
        legend: {
          position: "top-left",
          flipPage: false,
          value: true,
        },
        slider:
          type === "tournamentPlacement"
            ? false
            : {
                start: 0,
                end: 1,
              },
      };
  return data && data.length > 0 ? <Bar style={style} {...config} /> : null;
};

export default BarPlot;
